import { createUrlStore } from "../../../utils/createUrlStore.ts";
import { designerCanvasStore } from "../../Board/Workspaces/EditWorkspace/Designer/stores/designerCanvasStore.ts";

type State = {
  selectedAssetUuid: string | undefined;
};

type Actions = {
  setSelectedAssetUuid: (assetUuid: string) => void;
  clearSelectedAssetUuid: () => void;
};

export const selectedAssetUuidStore = createUrlStore<State, Actions>(
  { selectedAssetUuid: undefined },
  {
    selectedAssetUuid: {
      paramName: "assetUuid",
      serialize: (value) => value ?? "",
      deserialize: (value) => value || undefined,
    },
  },
  ({ set }) => ({
    setSelectedAssetUuid: (assetUuid: string) => {
      set({ selectedAssetUuid: assetUuid });
      // FIXME:  Move this reset action in an upper hook / helper to avoid interlinking stores between themselves.
      designerCanvasStore.reset();
    },
    clearSelectedAssetUuid: () => {
      set({ selectedAssetUuid: undefined });
    },
  }),
);
